const CSV = 'text/csv';

const XLXS =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const XLXM =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export { CSV, XLXS, XLXM };
